import { CheckedTickets } from '.'

export function sanitizeEditTicket(values: CheckedTickets): CheckedTickets {
  const sanitized = {
    ...values,
    request_ticket_receipts: values.request_ticket_receipts.map(receipt => ({
      ...receipt,
      currency_id: Number(receipt.currency_id),
      payment_resource_id: Number(receipt.payment_resource_id),
      reference_id: Number(receipt.reference_id),
      service_id: Number(receipt.service_id),
      request_ticket_receipt_images: receipt.request_ticket_receipt_images.map(
        image => ({
          ...image,
          request_ticket_receipt_image_id:
            image.request_ticket_receipt_image_id === ''
              ? null
              : +image.request_ticket_receipt_image_id,
          request_ticket_receipt_image_number:
            image.request_ticket_receipt_image_number === ''
              ? null
              : +image.request_ticket_receipt_image_number
        })
      )
    })),
    request_ticket_user_data: values.request_ticket_user_data.map(userData => ({
      ...userData,
      traveler: {
        ...userData.traveler,
        user_id: Number(userData.traveler.user_id)
      },
      user_id: Number(userData.traveler.user_id)
    }))
  }
  return sanitized
}
